import { Link } from "react-router-dom";
import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={`${styles.container} ${styles["container--1"]}`}>
        <div className={styles.footerOptions}>
          <span className={styles.optionsHeader}>Quick Links</span>
          <ul className={styles.list}>
            <li className={styles.linkContainer}>
              <Link to="/" className={styles.link}>
                Home Page
              </Link>
            </li>
            <li className={styles.linkContainer}>
              <Link to="/about" className={styles.link}>
                About Us Page
              </Link>
            </li>
            <li className={styles.linkContainer}>
              <Link to="/gallery" className={styles.link}>
                Our Photo Gallery
              </Link>
            </li>
            <li className={styles.linkContainer}>
              <Link to="/contact" className={styles.link}>
                Connect With Us
              </Link>
            </li>
          </ul>
        </div>
        <div className={styles.footerOptions}>
          <span className={styles.optionsHeader}>Social Media Links</span>
        </div>
        <div className={styles.footerOptions}>
          <span className={styles.optionsHeader}>Address</span>
        </div>
      </div>
      <div className={`${styles.container} ${styles["container--2"]}`}>
        <span className={styles.rightsText}>
          All rights reserved by @ssmmultisportsturf
        </span>
      </div>
    </footer>
  );
};

export default Footer;
